module.exports = require("core-js/library/fn/object/set-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/object/set-prototype-of.js
// module id = ./node_modules/@babel/runtime/core-js/object/set-prototype-of.js
// module chunks = 0